import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold" }, "Our Office", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  id: "map",
  class: "flex-grow"
}, null, -1)
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = { class: "opacity-70" }

import { useRoute } from "vue-router"
  import { computed, onMounted, watch } from "vue"
  import CardTemplate from "@/components/template/CardTemplate.vue"

  interface Coordinate {
    lat: number
    long: number
  }

  interface Area {
    northeast: Coordinate
    southwest: Coordinate
  }

  interface Location {
    city: string
    fullAddress: string
    country: string
    coordinates?: Coordinate
    area?: Area
  }

  interface Props {
    address: Location
    companyLogo: string
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OfficeContainer',
  props: {
    address: null,
    companyLogo: null
  },
  setup(__props: any) {

const props = __props as {
    address: Location
    companyLogo: string
  }

  

  const coords = computed(() => {
    if (props.address.coordinates) {
      return props.address.coordinates
    } else if (props.address.area) {
      return props.address.area.northeast
    } else return { lat: 0, long: 0 }
  })

  // eslint-disable-next-line
  let map: google.maps.Map

  /**
   * Initializes the element where the google map should be rendered.
   */
  const initMap = () => {
    // eslint-disable-next-line
    map = new google.maps.Map(document.getElementById("map") as HTMLElement, {
      center: { lat: coords.value.lat || 0, lng: coords.value.long || 0 },
      zoom: 16,
    })

    const icon = {
      url: props.companyLogo, // url
      // eslint-disable-next-line
      scaledSize: new google.maps.Size(50, 50), // scaled size
    }

    // eslint-disable-next-line
    const marker = new google.maps.Marker({
      position: { lat: coords.value.lat || 0, lng: coords.value.long || 0 },
      map: map,
      icon: icon,
    })
  }

  onMounted(() => {
    initMap()
  })

  watch(
    () => props.address,
    () => {
      initMap()
    },
    {
      deep: true,
    }
  )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CardTemplate, { class: "mx-3 h-[400px] flex flex-col" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _createElementVNode("span", _hoisted_3, _toDisplayString(__props.address.city) + ", " + _toDisplayString(__props.address.country), 1),
      _createElementVNode("address", _hoisted_4, _toDisplayString(__props.address.fullAddress), 1)
    ]),
    _: 1
  }))
}
}

})